import getNotificationDescription from './getNotificationDescription';

export default getNotificationDescription;
